export class UserAccountState {
  userAccountsList: any[] = [];
  selectedUserAccount: Object[] = [];
}
